import React, { Component } from "react";
import Select from "react-select";
//import makeAnimated from "react-select/animated";
import _ from "lodash";

class SelectFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterName: props.filterName,
      displayName: props.displayName,
      values: props.values,
      value: props.value,
      onChangeCallback: props.onChangeCallback
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.clearValue !== this.props.clearValue && this.props.clearValue === true) {
      this.setState({ values: [], value: null });
    } else if (Array.isArray(this.props.values)) {
      const oldPropsValuesLen = Array.isArray(prevProps.values) ? prevProps.values.length : 0;
      if (oldPropsValuesLen !== this.props.values.length) {
        this.setState({ values: this.props.values });
      }
    } else if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
      this.setState({ value: this.props.value });
    }
  }

    onChange(selections) {
    let values = [];
    let labels = [];
    let filteredDisplay = "";
    if (selections) {
      values = selections.length
        ? selections.map(x => x.value)
        : [selections.value];
      labels = selections.length
        ? selections.map(x => x.label)
        : [selections.label];
      let valuesDisplay = labels.join(", ");
      filteredDisplay =
        values && valuesDisplay
          ? `${this.state.displayName}: ${valuesDisplay}`
          : "";
    }
    this.setState({ values: values });
    if (this.props.isSingleSelect) {
      const value = values && values.length ? values[0] : null;
      const label = labels && labels.length ? labels[0] : null;
      this.state.onChangeCallback({
        filterName: this.state.filterName,
        value: value,
        label: label,
        filteredDisplay: filteredDisplay
      });
    } else {
      this.state.onChangeCallback({
        filterName: this.state.filterName,
        values: values,
        labels: labels,
        filteredDisplay: filteredDisplay
      });
    }
  }

  render() {
    if (!this.props.options) return (<span />);
    const isMulti = !this.props.isSingleSelect;
    let selectedValues = null;
    if (isMulti) {
      if (this.state.values && this.state.values.length) {
        selectedValues = _.filter(this.props.options, x => _.contains(this.state.values, x.value));
      }
    }
    else {
      selectedValues = this.state.value;
    }
    return (
      <span>
        <span className="filter-caption">{this.state.displayName}</span>
        <Select
          closeMenuOnSelect={!isMulti}
          isMulti={isMulti}
          isClearable={true}
          //components={makeAnimated()}
          options={this.props.options}
          onChange={this.onChange}
          value={selectedValues}
          onBlurResetsInput={false}
          onSelectResetsInput={false}
          onCloseResetsInput={false}
          classNamePrefix="react-select"
          placeholder={this.props.placeholder}
        />
      </span>
    );
  }
}
export default SelectFilter;


// WEBPACK FOOTER //
// ./src/components/SelectFilter.js